import React from 'react';
//import Radium, { StyleRoot } from 'radium'

function TextField({ label, fieldName, value, onChange, maxLength = '524288', disabled }) {
    return (
        <div className="form-group">
            <label className="col-sm-2 control-label">{label}</label>
            <div className="col-sm-8">
                <input className="form-control" type="text"
                    name={fieldName}
                    value={value}
                    onChange={onChange}
                    className="form-control"
                    maxLength={maxLength}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}
//module.exports = Radium(TextField);
export default TextField
